import React from 'react'
import { BsFillBagFill, BsFacebook } from 'react-icons/bs'
import { FaInstagramSquare } from 'react-icons/fa'

import { Link } from 'react-router-dom'

import { useGlobalContext } from '../context'
function Navbar() {
    const { totalItems, alert } = useGlobalContext()
    return (
        <div className='navbar'>
            <div className={`alert ${alert.show ? 'active' : ''}`}>
                <p>{alert.msg}</p>

            </div>
            <div className="container">
                <Link to={"/"} className="logo-link">
                    <h1>Praga-Store</h1>
                </Link>
                <div className="icons">
                    <a href="https://www.instagram.com/pragastore.eg/?hl=en" className='icon-link' target="_blank">
                        <FaInstagramSquare className='icon ig-icon' />
                    </a>
                    <a href="https://www.instagram.com/pragastore.eg/?hl=en" className='icon-link' target="_blank">
                        <BsFacebook className='icon fb-icon' />
                    </a>
                </div>
                <div className="navbar-bag-icon">
                    <Link to={"/bag"} className="icon-link">
                        <BsFillBagFill className='icon bag-icon' />
                    </Link>
                    <p className="amount">{totalItems}</p>
                </div>
            </div>
        </div>
    )
}

export default Navbar